/* eslint-disable react/prop-types */
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { React, forwardRef, useEffect, useCallback } from 'react';
// material
import { Box } from '@mui/material';
// utils
import track from 'utils/analytics';
import { useSelector } from 'react-redux';

// ----------------------------------------------------------------------

const Page = forwardRef(({ children, title = '', ...other }, ref) => {
  const { pathname } = useLocation();

  const { info } = useSelector((state) => state.main);

  const sendPageViewEvent = useCallback(() => {
    track.pageview({
      page_path: pathname,
    });
  }, []);

  useEffect(() => {
    sendPageViewEvent();
  }, [sendPageViewEvent]);

  return (
    <Box ref={ref} {...other}>
      <Helmet>
        <title>{info.name || title}</title>
        <link rel="shortcut icon" href={other.icon} />
      </Helmet>
      {children}
    </Box>
  );
});

export default Page;
